import * as React from "react";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { ImagesContext } from "../../Context";
import CustomChip from "../CustomChip";
import { formatMonetaryValue } from "../../utils/MonetaryFormatHelper";

interface Props {
  totalCharges: string;
  amountPaid: string;
}

const FinancialSummary: React.FC<Props> = ({ totalCharges, amountPaid }) => {
  const images = React.useContext(ImagesContext);
  const [expanded, setExpanded] = React.useState(false);

  const handleExpand = () => {
    setExpanded(!expanded);
  };

  const wasAmountPaid = !amountPaid || parseFloat(amountPaid) === 0;

  return (
    <Box
      sx={{
        backgroundColor: "white",
        borderRadius: "4px",
      }}
    >
      <Box
        className="claim-step-two-list-tile"
        sx={{
          boxShadow: expanded && "0px 7px 7px 0px #00000040",
        }}
      >
        <Box
          sx={{
            display: "flex",
            columnGap: "16px",
            alignItems: "center",
          }}
        >
          <div className="item-icon-container">
            <img
              src={images.check_mark_icon}
              alt="Insurance Icon"
              className="action-icon-image"
              style={{ width: 23, maxHeight: 23 }}
            />
          </div>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              rowGap: "10px",
            }}
          >
            <Box display="flex" alignItems="center" columnGap="16px">
              <Typography
                sx={{
                  fontSize: "18px",
                  lineHeight: "18px",
                  fontWeight: 700,
                  letterSpacing: "1px",
                  color: "#4A4442",
                }}
              >
                Financial Summary
              </Typography>
              <CustomChip label="No Errors" />
            </Box>
            <Typography
              sx={{
                fontSize: "14px",
                lineHeight: "18px",
                fontWeight: 500,
                letterSpacing: "1px",
                color: "#707070",
              }}
            >
              Total Charges: ${totalCharges ? formatMonetaryValue(totalCharges) : "0.00"} • Amount Paid: $
              {amountPaid ? formatMonetaryValue(amountPaid) : "0.00"}
            </Typography>
          </Box>
        </Box>

        <IconButton onClick={handleExpand}>
          {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        </IconButton>
      </Box>

      {expanded && (
        <Box className="info-container">
          <Grid container>
            <Grid item xs={3}>
              <Typography className="info-heading-label">
                Total Charges
              </Typography>
              <Typography className="info-heading-text">
                This is the total of the charge lines. You can change the total
                by editing the individual charges lines in step one if
                necessary.
              </Typography>
            </Grid>

            <Grid item xs={2}>
              <Typography className="info-heading-label">
                Total Charges:
              </Typography>
              <Typography className="info-heading-text">
                ${totalCharges ? formatMonetaryValue(totalCharges) : "0.00"}
              </Typography>
            </Grid>

            {!wasAmountPaid && (
              <>
                <Grid item xs={3}>
                  <Typography className="info-heading-label">
                    Amount Already Paid
                  </Typography>
                  <Typography className="info-heading-text">
                    This is the total of amounts already collected from the
                    patient or other payers.
                  </Typography>
                </Grid>

                <Grid item xs={2}>
                  <Typography className="info-heading-label">
                    Amount Paid:
                  </Typography>
                  <Typography className="info-heading-text">
                    ${amountPaid ? formatMonetaryValue(amountPaid) : "0.00"}
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default FinancialSummary;
